function moveNewsletter() {
  //console.log("Function moveNewsletter started!");
  jQuery('.custom-footer__newsletter.extended')
    .clone()
    .removeClass('custom-footer__newsletter extended odber')
    .appendTo('.overall-wrapper')
    .addClass('custom-footer__newsletter extended odber');
  jQuery('.overall-wrapper').find('#dklab_instagram_widget').remove();
}

var waitForEl = function (selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function () {
      waitForEl(selector, callback);
    }, 100);
  }
};

function animateScroll(hash) {
  //console.log("Function animateScroll started!");
  if (jQuery('body').hasClass('desktop')) {
    $('html, body').animate(
      {
        scrollTop: $(hash).offset().top + 'px',
      },
      800,
      'swing'
    );
  } else {
    setTimeout(() => {
      $('html, body').animate(
        {
          scrollTop: $(hash).offset().top + 'px',
        },
        800,
        'swing'
      );
    }, 2000);
  }
}

function removeNewsletterHash(hash) {
  //console.log("Function removeNewsletterHash started!");
  if ($(hash).length && hash === '#emailovyklub') {
    history.replaceState('', document.title, window.location.pathname);
  }
}

function removeOldNewsletter() {
  //console.log("Function removeOldNewsletter started!");
}

function dealWithNewsletter() {
  //console.log("Function dealWithNewsletter started!");
  if (window.location.hash) {
    var hash = window.location.hash;
    removeNewsletterHash(hash);
    waitForEl('.odber', function () {
      console.log('.odber found!');
      (function (next) {
        moveNewsletter();
        next();
      })(function () {
        animateScroll(hash);
      });
    });
  } else {
    waitForEl('.odber', function () {
      //console.log(".odber found!");
      moveNewsletter();
    });
  }
}

function hideExtendedDescriptionIntoTab() {
  const extendedDescription = jQuery('.extended-description');
  if (extendedDescription && window.matchMedia('(min-width: 1200px)').matches) {
    const parametersTabContent = `<div id="parametersTab" class="tab-pane fade no-comment" role="tabpanel"> ${extendedDescription.prop(
      'outerHTML'
    )} </div>`;
    const parametersTab = `<li class="shp-tab" data-testid="parametersTab" data-width="77"><a href="#parametersTab" class="shp-tab-link" role="tab" data-toggle="tab" aria-expanded="false">Parametry produktu</a></li>`;
    jQuery(parametersTab).insertAfter(jQuery('#p-detail-tabs > li:first-child'));
    jQuery(parametersTabContent).insertAfter(jQuery('#tab-content > #description'));
    jQuery(extendedDescription).remove();
  }
}

$(document).ready(function () {
  if (jQuery('body').hasClass('type-index')) {
    dealWithNewsletter();
  }
  if (jQuery('body').hasClass('type-detail')) {
    hideExtendedDescriptionIntoTab();
    jQuery('body.mobile .tab-content #description').addClass('otevreno');
    waitForEl('.benefitBanner', function () {
      jQuery('body.desktop .benefitBanner').insertBefore(jQuery('.p-detail-tabs-wrapper'));
    });
  }
});
